import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Home from './pages/Home';
import Admin from './pages/Admin';
import Records from './pages/Records';

function App() {
  return (
      <Router>
        <Routes>
            {/* <Route path="/" element={<Maintenance />} /> */}
            {/* <Route path="/:code" element={<Home />} /> */}
            <Route path="/" element={<Home />} />
            <Route
              path="/adminlogin"
              element={ <Admin /> }
            />
            <Route
              path="/adminrecords"
              element={ <Records /> }
            />
            
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
  );
}

export default App;
